export default function NoPage() {
  return (
    <div>
      <p className="text-center">Page doesn't exist</p>
      <div className="text-center">
        <p>:(</p>
      </div>
    </div>
  );
}